import(/* webpackMode: "eager" */ "/app/apps/web-app/src/app/_styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthValidator"] */ "/app/apps/web-app/src/components/auth/auth-validator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegister"] */ "/app/apps/web-app/src/components/service-worker-register.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalProviders"] */ "/app/apps/web-app/src/providers/global-providers.tsx");
